export default __webpack_public_path__ + "static/media/car-park.6fa44f74.svg";